// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1F-73","actions":"GroupTable_actions__1DGAP","deleteModalFooter":"GroupTable_deleteModalFooter__11bC7"};